import Row from '@amzn/meridian/row';
import { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const SelectOptionGroup = ({ label }) => {
  return (
    <SelectOption
      label=""
      disabled
      children={() => (
        <Row minHeight="35px">
          <Text fontFamily="bookerly" type="h100">
            <FormattedMessage id={label} />
          </Text>
        </Row>
      )}
    />
  );
};

export default SelectOptionGroup;
